import * as React from 'react'
import {
  Checkbox as CheckboxPrimitive,
  CheckboxProps as CheckboxPrimitiveProps,
} from '~/@/components/ui/checkbox-v2'
import { cn } from '~/@/lib/utils'

export interface CheckboxProps extends CheckboxPrimitiveProps {
  label?: string
  className?: string
}

export const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive>, CheckboxProps>(
  ({ className, id, label, ...props }, ref) => {
    // Use React.useId for a stable, unique id per instance if not provided
    const autoId = React.useId()
    const checkboxId = id || autoId

    return (
      <div className={cn('doss-checkbox flex items-center p-1', className)}>
        <CheckboxPrimitive className="peer" ref={ref} id={checkboxId} {...props} />
        {label && (
          <label className={cn('ps-2 cursor-pointer text-sm py-1')} htmlFor={checkboxId}>
            {label}
          </label>
        )}
      </div>
    )
  },
)

Checkbox.displayName = 'Checkbox'
